// import axios from "axios";
import React, { useEffect } from "react";
// import { Bounce, toast } from "react-toastify";

function AffordabilityWidget({payload}:any) {
          console.log(payload?.details.initiateTransaction.key,payload)

//     function loadWidget() {
//       // let key=payload?.details.initiateTransaction.key
//       let key='JPM7Fg'

//       console.log('===',key)
//       const widgetConfig = { key, amount };
//       try{
// // @ts-ignore
// // @ts-nocheck
//            let res=     payuAffordability.init(widgetConfig);
//            console.log(res)
//           //  res()
//       }catch(e){
//           console.log(e)
//       }
//     }
  
    // function appendScript() {
    //   let myScript = document.getElementById("payu-affordability-widget");
    //   if(!myScript){	
    //       myScript = document.createElement('script');
    //       myScript.setAttribute('src', "https://jssdk.payu.in/widget/affordability-widget.min.js");
    //       myScript.id="payu-affordability-widget";
    //       document.body.appendChild(myScript);
    //   }
    //   myScript.addEventListener('load', loadWidget, true);
    // }
  
    useEffect(() => {
        // appendScript();
        // makePayUPayment()
        // alert(JSON.stringify(payload))
        const submitButton = document.getElementById('handleSubmit');
        if (submitButton) {
            submitButton.click();
        }

    }, [])
    
  //   async function makePayUPayment() {
  //     const url = 'https://test.payu.in/_payment';
      
  //     const form = new FormData();
  //     form.append('key', payload?.details.initiateTransaction.key);
  //     form.append('surl', payload?.details.initiateTransaction.surl);
  //     form.append('furl', payload?.details.initiateTransaction.furl);
  //     form.append('amount', payload?.details.initiateTransaction.amount);
  //     form.append('productinfo', payload?.details.initiateTransaction.productinfo);
  //     form.append('firstname', payload?.details.initiateTransaction.firstname);
  //     form.append('email', payload?.details.initiateTransaction.email);
  //     form.append('phone', payload?.details.initiateTransaction.phone);
  //     form.append('txnid', payload?.details.initiateTransaction.txnid);
  //     form.append('hash', payload?.details.initiateTransaction.hash);
      
  //     try {
  //         const response:any = await axios.post(url, form, {
  //             headers: {
                
  //                 'Accept': 'text/plain',
  //                 'content-type':'application/x-www-form-urlencoded',
  //                 'Access-Control-Allow-Origin': '*',
  //               'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
  //               'Access-Control-Allow-Headers': 'Content-Type, Authorization'
  //             },
             
  //         });
  //         console.log('Response:', response);
          
  //         console.log('Response:', response.data);
  //         const parser = new DOMParser();
  //         const dom = parser.parseFromString(response.data, 'text/html');
  //         const errorReason = dom.querySelector("p span[style*='color:#FF0000']");
  //         const errorMessage = errorReason ? errorReason?.parentElement?.innerText : "Unknown Error";
  //         console.error('Extracted Error:', errorMessage);
  //         if(errorMessage){
  //           toast.error(errorMessage, {
  //                     position: 'top-right',
  //                     autoClose: 5000,
  //                     hideProgressBar: false,
  //                     closeOnClick: true,
  //                     pauseOnHover: true,
  //                     draggable: true,
  //                     progress: undefined,
  //                     theme: 'light',
  //                     transition: Bounce,
  //                     onClose: () => window.location.reload(),
  //                   })
  //         }else{
  //           console.log('suucess')
  //         }
         
  //     } catch (error:any) {
  //         console.error('Error:', error.response ? error.response.data : error.message);
  //     }
  // }
  

    return (
      <>
      <div id="payuWidget"/>  
      
  <form action="https://test.payu.in/_payment" method="post">
    <input type="hidden" name="key" value={payload?.details.initiateTransaction.key} />
    <input type="hidden" name="txnid" value={payload?.details.initiateTransaction.txnid} />
    <input type="hidden" name="productinfo" value={payload?.details.initiateTransaction.productinfo} />
    <input type="hidden" name="amount" value={payload?.details.initiateTransaction.amount} />
    <input type="hidden" name="email" value={payload?.details.initiateTransaction.email} />
    <input type="hidden" name="firstname" value={payload?.details.initiateTransaction.firstname} />
    {/* <input type="hidden" name="lastname" value="Kumar" /> */}
    <input type="hidden" name="surl" value={payload?.details.initiateTransaction.surl} />
    <input type="hidden" name="furl" value={payload?.details.initiateTransaction.furl}/>
    <input type="hidden" name="phone" value={payload?.details.initiateTransaction.phone} />
    <input type="hidden" name="hash" value={payload?.details.initiateTransaction.hash} />
    <input type="hidden" name="enforce_paymethod" value={payload?.details.initiateTransaction.enforce_paymethod} />

    <input type="submit" style={{opacity:0}} id='handleSubmit' value="Submit" />
  </form>

 
      </>
    )
}

export default AffordabilityWidget;